import React from 'react';

export default function About() {
  return (
    <section className="py-16 px-8 bg-white text-gray-800">
      <h2 className="text-3xl font-bold text-center mb-6">About Me</h2>
      <p className="max-w-3xl mx-auto text-center text-lg">
        I'm a Computer Science graduate from Machakos University with hands-on experience in network operations,
        cybersecurity, and cloud-native technologies. I've worked at NTT DATA as a Technical Support Engineer and hold multiple certifications in networking and Kubernetes.
        I'm passionate about solving technical problems, building secure and scalable systems, and continuously learning.
      </p>
    </section>
  );
}
